<template>
    <div class="col-11">
        <div id="team-details-table" class="table-responsive">
            <table class="table">
                <thead class="thead-dark">
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">TRAINER</th>
                    <th scope="col">JOCKEY</th>
                    <th scope="col">RUNS</th>
                    <th scope="col">1ST</th>
                    <th scope="col">2ND</th>
                    <th scope="col">3RD</th>
                    <th scope="col">WIN%</th>
                    <th scope="col">PLACE%</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(trainerJockeyItem, index) in trainerJockeyCombo" :key="index">
                    <td>{{trainerJockeyItem.horseNumber}}</td>
                    <td class="text-left">{{trainerJockeyItem.trainerName | init }}</td>
                    <td class="text-left">{{trainerJockeyItem.jockeyName | jockeyinit | init }}</td>
                    <td>{{trainerJockeyItem.runs}}</td>
                    <td>{{trainerJockeyItem.first}}</td>
                    <td>{{trainerJockeyItem.second}}</td>
                    <td>{{trainerJockeyItem.third}}</td>
                    <td>{{trainerJockeyItem.winPerc}}</td>
                    <td>{{trainerJockeyItem.placePerc}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import jockeyTrainer from '../components/mixins/Jockey-TrainerName'
    export default {
        name: 'RaceCardTrainerJockeyCombo',
         mixins:[jockeyTrainer],
        data: function () {
            return {
            };
        },
        props: {
            trainerJockeyCombo: Array
        },
        filters:{
            
        },
        methods: {
            getImage(imagePath, fileType = 'svg') {
                return require('../assets/images/' + imagePath + '.' + fileType);
            }
        },
        mounted: function() {
        }
    }
    
</script>

<style scoped>
    table {
        border: 1px solid #7c7c7c !important;
        box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.4);
    }

    thead {
        background-color: #000000 !important;
        line-height: 0.7;
    }

    tr {
        text-align: center;
    }

    td {
        line-height: 0.9;
    }
</style>
